module.exports = __webpack_public_path__ + "img/usha.0eb8a616.jpg";